import {forwardRef, useCallback, useImperativeHandle, useMemo} from 'react';
import {useFormikContext} from 'formik';
import _ from 'lodash';

function filterOnField(filterFormatters, attributePath, value, arrayHelpers, presentFilters, handleSubmit) {
    // if filterFormatters does not contain attributePath, then there is no configured filter on this attribute, so nothing we can do
    const filterFormatter = _.find(filterFormatters, {attributePath});

    if (filterFormatter == null) return false;

    const filterComponent = filterFormatter.component;
    const initialFilterForm = filterComponent.initialFormData(filterFormatter, value);
    const currentIx = _.indexOf(presentFilters, filterFormatter.id);
    const alreadyFiltered = currentIx !== -1;

    if (alreadyFiltered) {
        arrayHelpers.replace(currentIx, initialFilterForm);
    } else {
        arrayHelpers.unshift(initialFilterForm);
    }

    // we immediately apply the filter after setting it
    handleSubmit();

    return true;
}

export const FilterOnFieldSetup = forwardRef(({filterFormatters, arrayHelpers}, ref) => {
    const {values, handleSubmit} = useFormikContext();
    const presentFilters = useMemo(() => _.map(values.filters, 'id'), [values.filters]);

    const filterOnFieldFn = useCallback(
        (fieldName, value) =>
            filterOnField(filterFormatters, fieldName, value, arrayHelpers, presentFilters, handleSubmit),
        [filterFormatters, arrayHelpers, values.filters],
    );

    // the `filterOnField` function gets exposed (via the ref) to the parent component, so that the filter panel form can be controlled
    // by the list component, for example with the right-click-filter feature
    useImperativeHandle(ref, () => ({
        filterOnField: filterOnFieldFn,
    }));

    return null;
});
FilterOnFieldSetup.displayName = 'FilterOnFieldSetup';
